var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3514 7.77051C36.2889 8.99885 37.0826 10.3333 37.7163 11.7472L19.7395 25.1772L12.2266 20.4042V14.6622L19.7395 19.4351L35.3514 7.77051Z",
    fill: "#21A038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55927 19.9991C4.55927 19.7414 4.56547 19.4855 4.57787 19.231L0.0247968 19.0049C0.00929965 19.3347 5.50217e-06 19.6677 5.50217e-06 20.0037C-0.0019317 22.6295 0.507688 25.2298 1.49964 27.6554C2.49159 30.0811 3.94634 32.2844 5.78045 34.1389L9.01005 30.8674C7.59823 29.4424 6.47822 27.7486 5.7144 25.8834C4.95058 24.0182 4.55802 22.0185 4.55927 19.9991Z",
    fill: "url(#paint0_linear_1345_26630)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7355 4.62042C19.9896 4.62042 20.2422 4.62985 20.4932 4.64241L20.7211 0.0265021C20.3947 0.0107964 20.0661 0.00294452 19.7355 0.00294452C17.1434 -0.000259062 14.5763 0.515474 12.1814 1.52053C9.78659 2.52559 7.61123 4.00017 5.78027 5.85962L9.00988 9.13268C10.4161 7.70139 12.0876 6.5659 13.9283 5.79152C15.769 5.01715 17.7425 4.61915 19.7355 4.62042Z",
    fill: "url(#paint1_linear_1345_26630)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7361 35.3798C19.482 35.3798 19.2294 35.3798 18.9768 35.3594L18.749 39.9737C19.0765 39.9904 19.4056 39.9989 19.7361 39.9989C22.3272 40.0016 24.8931 39.4855 27.2866 38.4802C29.6802 37.4748 31.8541 36 33.6837 34.1406L30.4603 30.8691C29.0538 32.2997 27.3825 33.4345 25.5422 34.2086C23.7019 34.9827 21.7287 35.3808 19.7361 35.3798Z",
    fill: "url(#paint2_linear_1345_26630)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2902 7.30319L32.1273 4.43689C28.6202 1.55876 24.2423 -0.00798939 19.7295 3.06379e-05V4.61908C22.7854 4.61524 25.7703 5.55117 28.2902 7.30319Z",
    fill: "url(#paint3_linear_1345_26630)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4702 20.0001C39.4727 18.7985 39.369 17.5989 39.1602 16.416L34.9125 19.5886C34.9125 19.7253 34.9125 19.8619 34.9125 20.0001C34.9136 22.1491 34.4691 24.2743 33.6079 26.238C32.7466 28.2017 31.4878 29.9601 29.9131 31.3992L32.9769 34.831C35.0242 32.9579 36.6601 30.6698 37.7787 28.1149C38.8974 25.5599 39.4737 22.7952 39.4702 20.0001Z",
    fill: "#21A038"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7356 35.3802C17.6149 35.3809 15.5178 34.9303 13.5799 34.0575C11.6421 33.1847 9.90668 31.9091 8.48613 30.3135L5.10156 33.4169C6.94953 35.4921 9.20724 37.1503 11.7283 38.2843C14.2493 39.4181 16.9773 40.0024 19.7356 39.9991V35.3802Z",
    fill: "url(#paint4_linear_1345_26630)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55867 8.59967L6.49642 5.16797C4.44858 7.04068 2.81201 9.32871 1.69285 11.8837C0.573697 14.4386 -0.0030512 17.2034 1.21392e-05 19.9988H4.55928C4.55834 17.85 5.0029 15.7247 5.86412 13.761C6.72535 11.7973 7.98405 10.0389 9.55867 8.59967Z",
    fill: "url(#paint5_linear_1345_26630)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1345_26630",
    x1: 6.70253,
    y1: 33.5625,
    x2: 1.60155,
    y2: 19.0125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C9DA26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1345_26630",
    x1: 7.08203,
    y1: 6.67631,
    x2: 19.9552,
    y2: 1.83568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0FA7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0098F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0290EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1345_26630",
    x1: 18.4484,
    y1: 37.2111,
    x2: 32.9754,
    y2: 33.9728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#86C239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#219F38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1345_26630",
    x1: 18.7811,
    y1: 1.54704,
    x2: 31.2135,
    y2: 5.3327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0290EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0C89CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1345_26630",
    x1: 6.24525,
    y1: 32.8546,
    x2: 19.7902,
    y2: 37.8497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EAE616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D8DF1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BAD52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1345_26630",
    x1: 1.6985,
    y1: 20.558,
    x2: 7.24536,
    y2: 6.32019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#81C45E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0FA7DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSber);
export default __webpack_public_path__ + "static/media/sber.76557f82b9147f7cfdd1b8dd97d1b9f7.svg";
export { ForwardRef as ReactComponent };